(function () {
var box = document.getElementById('updpx-bundle');
if (!box) return;
var abId = '';
var abEndpoint = box.dataset.abendpoint || '';
function abPick() {
var sets = Array.prototype.slice.call(box.querySelectorAll('.updpx-abset'));
if (!sets.length) return;
var key = 'updpx-ab-' + (box.dataset.product || '');
var chosen = null;
var saved = '';
try { saved = window.localStorage.getItem(key) || ''; } catch (e) {}
if (saved) { chosen = sets.filter(function (s) { return s.dataset.ab === saved; })[0] || null; }
if (!chosen) {
var total = 0;
sets.forEach(function (s) { total += Math.max(0, parseInt(s.dataset.abw, 10) || 0); });
var r = Math.random() * (total || sets.length);
var acc = 0;
for (var i = 0; i < sets.length; i++) {
acc += total ? Math.max(0, parseInt(sets[i].dataset.abw, 10) || 0) : 1;
if (r < acc) { chosen = sets[i]; break; }
}
chosen = chosen || sets[0];
try { window.localStorage.setItem(key, chosen.dataset.ab || ''); } catch (e) {}
}
sets.forEach(function (s) { if (s !== chosen) s.parentNode.removeChild(s); });
chosen.removeAttribute('hidden');
abId = chosen.dataset.ab || '';
}
abPick();
var currency = box.dataset.currency || 'EUR';
var isHorizontal = box.dataset.layout === 'horizontal';
var horVars = box.querySelector('.updpx-hor-vars');
function fmtPrice(raw) {
var n = parseFloat(String(raw || '').replace(',', '.').replace(/[^0-9.]/g, ''));
return isFinite(n) && n >= 0 ? currency + ' ' + n.toFixed(2) : '';
}
var tierRef = null;
function tierReference() {
if (tierRef) return tierRef;
var vs = [];
try { vs = JSON.parse(document.getElementById('updpx-variants').textContent) || []; } catch (e) {}
var t1 = null;
box.querySelectorAll('.updpx-tier[data-updpx-total]').forEach(function (t) {
if (!t1 && (parseInt(t.dataset.updpxPaid, 10) || 1) === 1 && (parseInt(t.dataset.updpxQty, 10) || 1) === 1) t1 = t;
});
var target = t1 ? parseFloat(t1.dataset.updpxTotal) : NaN;
var selId = String(box.dataset.selvariant || '');
var best = null;
vs.forEach(function (x) {
var p = (parseFloat(x.price) || 0) / 100;
if (!(p > 0)) return;
var score = isFinite(target) ? Math.abs(p - target) : (String(x.id) === selId ? 0 : 1);
if (!best || score < best.score) best = { x: x, p: p, score: score };
});
var t1c = t1 ? parseFloat(t1.dataset.updpxCompare || '') : NaN;
if (t1 && isFinite(target) && target > 0) tierRef = { price: target, compare: isFinite(t1c) && t1c > 0 ? t1c : target };
else if (best) tierRef = { price: best.p, compare: (parseFloat(best.x.compare_at_price) || 0) / 100 || best.p };
else return null;
box.querySelectorAll('.updpx-tier[data-updpx-total]').forEach(function (t) {
t.dataset.updpxTotal0 = t.dataset.updpxTotal;
t.dataset.updpxCompare0 = t.dataset.updpxCompare || '';
});
return tierRef;
}
function vUnit(v) { return (parseFloat(String((v && v.price) || '0').replace(/[^0-9.]/g, '')) || 0) / 100; }
function priceTier(t, units) {
if (!units.length || units.some(function (u) { return !(vUnit(u) > 0); })) return;
var ref = tierReference();
var df = parseFloat(t.dataset.updpxDf);
var paid = Math.min(parseInt(t.dataset.updpxPaid, 10) || 1, units.length);
var prices = units.map(vUnit).sort(function (a, b) { return b - a; });
var sumPaid = 0;
for (var k = 0; k < paid; k++) sumPaid += prices[k];
var total;
if (isFinite(df) && df > 0) {
total = sumPaid * df;
} else {
if (!ref) return;
var t0 = parseFloat(t.dataset.updpxTotal0);
if (!isFinite(t0)) return;
total = t0 * sumPaid / (ref.price * paid);
}
t.dataset.updpxTotal = total.toFixed(2);
var pEl = t.querySelector('.updpx-tier-price strong');
if (pEl) pEl.textContent = fmtPrice(total.toFixed(2));
showSavings(t, prices.reduce(function (s, p) { return s + p; }, 0) + (parseFloat(t.dataset.updpxGiftvalue) || 0), total);
}
var SAVE_WORDS = /économis|spar|rispar|save|ahorr|bespaar|poup/i;
function showSavings(t, value, total) {
var priceBox = t.querySelector('.updpx-tier-price');
var cEl = t.querySelector('.updpx-tier-price s');
var sub = t.querySelector('.updpx-tier-main small');
var isSave = !!sub && SAVE_WORDS.test(sub.textContent) && /\d/.test(sub.textContent);
if (value - total > 0.005) {
t.dataset.updpxCompare = value.toFixed(2);
if (!cEl && priceBox) { cEl = document.createElement('s'); priceBox.appendChild(cEl); }
if (cEl) { cEl.textContent = fmtPrice(value.toFixed(2)); cEl.style.display = ''; }
if (isSave) { sub.textContent = sub.textContent.replace(/(\d+(?:[.,'']\d{1,3})*(?:[.,]\d{1,2})?)(?!.*\d)/, (value - total).toFixed(2)); sub.style.display = ''; }
} else {
t.dataset.updpxCompare = '';
if (cEl) cEl.style.display = 'none';
if (isSave) sub.style.display = 'none';
}
}
function updateTierPricesForVariant(v) {
if (!v || !(vUnit(v) > 0)) return;
box.querySelectorAll('.updpx-tier[data-updpx-total]').forEach(function (t) {
var n = parseInt(t.dataset.updpxQty, 10) || 1;
var units = [];
for (var k = 0; k < n; k++) units.push(v);
priceTier(t, units);
});
}
var mkt = window.Shopify && window.Shopify.currency;
var mktRate = mkt ? parseFloat(mkt.rate) : NaN;
if (mkt && mkt.active && mkt.active !== currency && isFinite(mktRate) && mktRate > 0) {
var unitBase = parseFloat(box.dataset.unitbase || '');
var pvs = [];
try { pvs = JSON.parse(document.getElementById('updpx-variants').textContent); } catch (e) {}
var pv = pvs.filter(function (v) { return String(v.id) === String(box.dataset.selvariant || ''); })[0] || pvs[0];
var unitP = pv ? (parseFloat(pv.price) || 0) / 100 : 0;
var exact = unitP > 0 && unitBase > 0;
var r2 = function (n) { return Math.round(n * 100) / 100; };
var convertAmounts = function (txt, k) {
return String(txt || '').replace(/(US\$|CA\$|A\$|\$|€|£|USD|EUR|CHF|CAD|GBP|AUD)\s?(\d+(?:[.,]\d{1,2})?)/g, function (m, c, n) {
return mkt.active + ' ' + (parseFloat(n.replace(',', '.')) * k).toFixed(2);
});
};
box.querySelectorAll('.updpx-tier[data-updpx-total]').forEach(function (t) {
var totalB = parseFloat(t.dataset.updpxTotal);
if (!isFinite(totalB)) return;
var paid = parseInt(t.dataset.updpxPaid, 10) || 1;
var totalP = exact ? r2(unitP * paid - r2((unitBase * paid - totalB) * mktRate)) : r2(totalB * mktRate);
var cmpB = parseFloat(t.dataset.updpxCompare || '');
if (isFinite(cmpB)) t.dataset.updpxCompare = (exact ? r2(cmpB * unitP / unitBase) : r2(cmpB * mktRate)).toFixed(2);
var gvB = parseFloat(t.dataset.updpxGiftvalue || '');
if (isFinite(gvB)) t.dataset.updpxGiftvalue = r2(gvB * mktRate).toFixed(2);
t.dataset.updpxTotal = totalP.toFixed(2);
var sub = t.querySelector('.updpx-tier-main small');
if (sub) sub.textContent = convertAmounts(sub.textContent, totalB > 0 ? totalP / totalB : mktRate);
});
box.querySelectorAll('.updpx-gtile-price, .updpx-giftband-right s').forEach(function (el) { el.textContent = convertAmounts(el.textContent, mktRate); });
currency = mkt.active;
}
box.querySelectorAll('.updpx-tier[data-updpx-total]').forEach(function(t) {
var pEl = t.querySelector('.updpx-tier-price strong');
var cEl = t.querySelector('.updpx-tier-price s');
if (pEl && t.dataset.updpxTotal) pEl.textContent = fmtPrice(t.dataset.updpxTotal);
if (cEl && t.dataset.updpxCompare) cEl.textContent = fmtPrice(t.dataset.updpxCompare);
});
function honestSavingsOnLoad() {
var vs0 = [];
try { vs0 = JSON.parse(document.getElementById('updpx-variants').textContent) || []; } catch (e) {}
var sid0 = String(box.dataset.selvariant || '');
var cur0 = vs0.filter(function (x) { return String(x.id) === sid0; })[0] || vs0[0];
var unitBase = parseFloat(box.dataset.unitbase || '');
if (cur0 && unitBase > 0 && Math.abs(vUnit(cur0) - unitBase) > 0.02 && !/[?&]variant=/.test(location.search || '')) {
var color0 = cur0.option1, aligned = null;
vs0.forEach(function (x) {
if (x.available === false) return;
if (Math.abs(vUnit(x) - unitBase) > 0.02) return;
if (!aligned || (color0 && x.option1 === color0 && aligned.option1 !== color0)) aligned = x;
});
if (aligned) { box.dataset.selvariant = String(aligned.id); cur0 = aligned; }
}
var unit0 = vUnit(cur0);
if (!(unit0 > 0)) return;
box.querySelectorAll('.updpx-tier[data-updpx-total]').forEach(function (t) {
var total = parseFloat(t.dataset.updpxTotal);
if (!isFinite(total)) return;
showSavings(t, unit0 * (parseInt(t.dataset.updpxQty, 10) || 1) + (parseFloat(t.dataset.updpxGiftvalue) || 0), total);
});
}
honestSavingsOnLoad();
var simplePriceEl = box.querySelector('.updpx-simple-price');
var simpleCompEl = box.querySelector('.updpx-simple-compare');
var st0 = box.querySelector('.updpx-tier[data-updpx-total]');
if (simplePriceEl && st0 && st0.dataset.updpxTotal) simplePriceEl.textContent = fmtPrice(st0.dataset.updpxTotal);
if (simpleCompEl && st0) {
if (st0.dataset.updpxCompare) simpleCompEl.textContent = fmtPrice(st0.dataset.updpxCompare);
else simpleCompEl.style.display = 'none';
}
function abSession() {
var k = 'updpx-ab-sid', sid = '';
try {
sid = window.localStorage.getItem(k) || '';
if (!sid) { sid = Math.random().toString(36).slice(2, 12) + Date.now().toString(36); window.localStorage.setItem(k, sid); }
} catch (e) { sid = 'anon'; }
return sid;
}
function abBeacon(kind) {
if (!abId || !abEndpoint) return;
var payload = JSON.stringify({ v: abId, k: kind, s: abSession() });
try { if (navigator.sendBeacon && navigator.sendBeacon(abEndpoint, new Blob([payload], { type: 'text/plain' }))) return; } catch (e) {}
try { fetch(abEndpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: payload, keepalive: true, mode: 'cors' }).catch(function () {}); } catch (e) {}
}
abBeacon('view');
var variants = [];
try { variants = JSON.parse(document.getElementById('updpx-variants').textContent); } catch (e) {}
var hiddenOpts = (box.dataset.hiddenopts || '').split(',').filter(Boolean).map(Number);
var allHidden = box.dataset.allhidden === '1';
var unitVar = null;
if (allHidden) {
variants.forEach(function (x) { if (x.available !== false && (!unitVar || x.price < unitVar.price)) unitVar = x; });
unitVar = unitVar || variants[0] || null;
if (unitVar) box.dataset.selvariant = String(unitVar.id);
}
var selId0 = parseInt(box.dataset.selvariant, 10);
var baseVar = variants.find(function(x) { return x.id === selId0; }) || variants[0] || null;
var hiddenDefaults = {}; // { optionIndex: valeur fixée }
if (baseVar) {
hiddenOpts.forEach(function(i) {
hiddenDefaults[i] = baseVar['option' + (i + 1)];
});
}
if (hiddenOpts.length) {
box.querySelectorAll('[data-optwrap]').forEach(function(wrap) {
var i = parseInt(wrap.dataset.optwrap || '-1', 10);
if (hiddenOpts.indexOf(i) >= 0) wrap.style.display = 'none';
});
box.querySelectorAll('[data-swatches]').forEach(function(sw) {
var i = parseInt(sw.dataset.swatches || '-1', 10);
if (hiddenOpts.indexOf(i) >= 0) sw.style.display = 'none';
});
}
var hasVars = box.dataset.hasvars === '1';
var hasCustom = box.dataset.hascustom === '1';
var chooseMsg = box.dataset.choose || 'Please choose the options for each item';
var soldOutIds = (box.dataset.soldoutids || '').split(',').filter(Boolean).map(function (s) { return parseInt(s, 10); });
if (soldOutIds.length) variants.forEach(function (x) { if (soldOutIds.indexOf(x.id) >= 0) x.available = false; });
var section = box.closest('section') || document;
function isBuyForm(f) { return f && !/installment/i.test(f.id || '') && !f.classList.contains('installment') && !!(f.querySelector('[name="add"], button[type="submit"]') || f.querySelector('input[name="id"]')); }
function getForm() {
var all = Array.prototype.slice.call(section.querySelectorAll('form[action*="/cart/add"]'));
if (!all.length) all = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
return all.filter(isBuyForm)[0] || all[0] || null;
}
function setQtyOn(form, q) {
if (!form) return;
var input = form.querySelector('input[name="quantity"]');
if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'quantity'; form.appendChild(input); }
input.value = q;
var visible = form.querySelector('quantity-input input, .quantity__input');
if (visible) visible.value = q;
}
function setQty(q) {
var all = Array.prototype.slice.call(section.querySelectorAll('form[action*="/cart/add"]'));
if (!all.length) all = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
setQtyOn(all.filter(isBuyForm)[0] || null, q);
}
var tiers = box.querySelectorAll('[data-updpx-qty]');
var gTiles = box.querySelector('[data-updpx-gtiles]');
function placeGiftTiles() {
if (!gTiles) return;
var form = getForm();
var abtn = form && form.querySelector('button[name="add"], button[type="submit"]');
if (!abtn) return;
var anchor = abtn.parentNode && abtn.parentNode !== form ? abtn.parentNode : abtn;
if (anchor.nextElementSibling !== gTiles) anchor.insertAdjacentElement('afterend', gTiles);
}
function syncGiftTiles(selTier) {
if (!gTiles) return;
var idx = Array.prototype.indexOf.call(tiers, selTier);
gTiles.querySelectorAll('.updpx-gtile').forEach(function (g) {
var min = parseInt(g.dataset.min, 10) || 0;
g.classList.toggle('is-locked', idx < 0 || min > idx);
});
placeGiftTiles();
}
tiers.forEach(function (t) {
function sel() {
tiers.forEach(function (x) { x.classList.toggle('is-sel', x === t); });
syncGiftTiles(t);
if (!hasVars && !hasCustom) setQty(parseInt(t.dataset.updpxQty, 10) || 1);
if (isHorizontal && horVars) {
var prev = horVars.querySelector('.updpx-tier-vars');
if (prev && prev._updpxOwner) prev._updpxOwner.appendChild(prev);
var tVars = t.querySelector('.updpx-tier-vars');
if (tVars) { tVars._updpxOwner = t; horVars.appendChild(tVars); horVars.hidden = false; }
else { horVars.hidden = true; }
}
}
t.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === t) { e.preventDefault(); sel(); } });
t._updpxSel = sel;
});
document.addEventListener('click', function (e) {
var t = e.target.closest && e.target.closest('.updpx-tier');
if (!t || !box.contains(t)) return;
var tag = e.target.tagName;
if (tag === 'SELECT' || tag === 'OPTION' || tag === 'INPUT' || tag === 'LABEL' || e.target.closest('.updpx-sw')) return;
if (t._updpxSel) t._updpxSel();
});
var def = box.querySelector('.updpx-tier.is-sel');
if (!def && tiers.length) { def = tiers[Math.min(1, tiers.length - 1)]; def.classList.add('is-sel'); }
var syncSelQty = function () { var s = box.querySelector('.updpx-tier.is-sel'); if (s && !hasVars && !hasCustom) setQty(parseInt(s.dataset.updpxQty, 10) || 1); };
syncSelQty();
syncGiftTiles(def);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { placeGiftTiles(); syncSelQty(); });
window.addEventListener('load', function () { placeGiftTiles(); syncSelQty(); });
if (isHorizontal && horVars && def) {
var defVars = def.querySelector('.updpx-tier-vars');
if (defVars) { defVars._updpxOwner = def; horVars.appendChild(defVars); horVars.hidden = false; }
}
if (hasVars) {
var selId = parseInt(box.dataset.selvariant, 10);
var selVar = variants.find(function (x) { return x.id === selId; }) || variants[0];
if (selVar) {
box.querySelectorAll('.updpx-var-row select').forEach(function (s) {
var want = selVar['option' + (parseInt(s.dataset.opt, 10) + 1)];
if (want != null) s.value = want;
});
updateTierPricesForVariant(selVar);
}
}
if (allHidden && unitVar) updateTierPricesForVariant(unitVar);
var soldOut = box.dataset.soldout || 'Épuisé';
var colorOpt = parseInt(box.dataset.coloropt, 10);
function optVal(x, i) { return x['option' + (i + 1)]; }
function rowValues(row) {
var opts = [];
row.querySelectorAll('select').forEach(function (s) { opts[parseInt(s.dataset.opt, 10)] = s.value; });
hiddenOpts.forEach(function(i) { if (hiddenDefaults[i] != null) opts[i] = hiddenDefaults[i]; });
return opts;
}
function resolveRow(row) {
if (!hasVars) { var selId0 = parseInt(box.dataset.selvariant, 10); return variants.find(function (x) { return x.id === selId0; }) || variants[0] || null; }
var opts = rowValues(row);
return variants.find(function (x) {
return (opts[0] == null || x.option1 === opts[0]) && (opts[1] == null || x.option2 === opts[1]) && (opts[2] == null || x.option3 === opts[2]);
}) || null;
}
var uploadEndpoint = abEndpoint ? abEndpoint.replace('bundle-ab', 'bundle-image-upload') : 'https://ultrascale.app/api/public/bundle-image-upload';
function rowProps(row) {
var props = {}, missing = false;
row.querySelectorAll('[data-custom]').forEach(function (el) {
if (el.closest('.updpx-name-f[hidden]')) return;
var wrap = el.closest('[data-customwrap]');
var optional = wrap && wrap.dataset.optional === '1';
var v = (el.value || '').trim();
if (!v && !optional && el.dataset.custom.charAt(0) !== '_') { missing = true; if (wrap) wrap.classList.add('is-missing'); } else if (wrap) wrap.classList.remove('is-missing');
if (v) props[el.dataset.custom] = v;
});
return missing ? null : props;
}
document.addEventListener('click', function(e) {
var btn = e.target.closest('.updpx-imgup-btn');
if (!btn) return;
var inp = btn.querySelector('input[type=file]');
if (!inp || e.target === inp) return;
e.preventDefault();
inp.click();
}, false);
document.addEventListener('change', function(e) {
var inp = e.target;
if (inp.type !== 'file' || !inp.closest('[data-custupload]')) return;
var upwrap = inp.closest('[data-custupload]');
var hidden = upwrap.querySelector('input[type=hidden]:not([data-custom="_preview"])');
var thumb = upwrap.querySelector('.updpx-imgup-thumb');
var lbl = upwrap.querySelector('.updpx-imgup-label');
var btn = upwrap.querySelector('.updpx-imgup-btn');
var file = inp.files && inp.files[0];
if (!file) return;
if (btn) btn.classList.add('has-photo', 'is-busy');
if (lbl) lbl.textContent = upwrap.dataset.wUploading || '…';
if (hidden) hidden.value = '';
shrinkPhoto(file, function (f) {
if (thumb) { thumb.src = URL.createObjectURL(f); thumb.hidden = false; }
var fd = new FormData();
fd.append('file', f, f.name || 'photo.jpg');
fetch(uploadEndpoint, { method: 'POST', body: fd })
.then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
.then(function(data) {
if (btn) btn.classList.remove('is-busy');
if (data.url) {
if (hidden) { hidden.value = data.url; }
if (lbl) lbl.textContent = upwrap.dataset.wChange || '✓';
var outer = upwrap.closest('[data-customwrap]');
if (outer) outer.classList.remove('is-missing');
if (upwrap.dataset.preview === '1') { if (rowName(upwrap) || !rowNameInput(upwrap)) aiPreview(upwrap); else askName(upwrap); }
}
})
.catch(function() { if (btn) btn.classList.remove('is-busy', 'has-photo'); if (thumb) thumb.hidden = true; if (lbl) lbl.textContent = upwrap.dataset.wFailed || 'Erreur'; });
});
}, false);
function shrinkPhoto(file, cb) {
if (file.size < 900000 && /jpe?g|png|webp/i.test(file.type)) return cb(file);
var u = URL.createObjectURL(file), im = new Image();
im.onload = function () {
var k = Math.min(1, 1600 / Math.max(im.naturalWidth || 1, im.naturalHeight || 1));
var c = document.createElement('canvas');
c.width = Math.max(1, Math.round(im.naturalWidth * k)); c.height = Math.max(1, Math.round(im.naturalHeight * k));
try { c.getContext('2d').drawImage(im, 0, 0, c.width, c.height); } catch (e) { URL.revokeObjectURL(u); return cb(file); }
URL.revokeObjectURL(u);
c.toBlob(function (b) { cb(b ? new File([b], 'photo.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', 0.88);
};
im.onerror = function () { URL.revokeObjectURL(u); cb(file); };
im.src = u;
}
var previewEndpoint = uploadEndpoint.replace('bundle-image-upload', 'bundle-preview');
function rowOf(upwrap) { return upwrap.closest('[data-row]') || upwrap.closest('.updpx-var-opts'); }
function rowNameInput(upwrap) { var row = rowOf(upwrap); return row && row.querySelector('input[type=text][data-custom], input[type=search][data-custom]'); }
function rowName(upwrap) { var t = rowNameInput(upwrap); return t ? (t.value || '').trim().slice(0, 30) : ''; }
function askName(upwrap) {
var ask = upwrap.querySelector('.updpx-aiprev-ask');
if (ask) ask.hidden = false;
var t = rowNameInput(upwrap);
if (t) { try { t.focus(); } catch (e) {} }
}
function galSlide(upwrap) {
var g = document.querySelector('media-gallery');
var list = g && g.querySelector('.product__media-list');
var first = list && list.querySelector('.product__media-item');
if (!first) return null;
var row = rowOf(upwrap);
var rows = row && row.parentNode ? row.parentNode.querySelectorAll('[data-row]') : [];
var idx = Math.max(0, Array.prototype.indexOf.call(rows, row));
var mid = 'updpx-prev-' + idx;
var li = list.querySelector('[data-media-id="' + mid + '"]');
if (li) return li;
li = document.createElement('li');
li.id = 'Slide-' + mid;
li.className = 'product__media-item grid__item slider__slide updpx-galprev';
li.setAttribute('data-media-id', mid);
li.innerHTML = '<div class="updpx-galprev-in"><img alt="" hidden><span class="updpx-galprev-wait"><span class="updpx-galprev-msg"></span><span class="updpx-pbar"><i></i></span></span>' + (rows.length > 1 ? '<span class="updpx-galprev-tag">#' + (idx + 1) + '</span>' : '') + '</div>';
list.insertBefore(li, first);
var th = g.querySelector('.thumbnail-list');
var th0 = th && th.querySelector('.thumbnail-list__item');
if (th0) {
var tli = document.createElement('li');
tli.id = 'Slide-Thumbnails-' + mid;
tli.className = 'thumbnail-list__item slider__slide updpx-galprev-th';
tli.setAttribute('data-target', mid);
tli.style.setProperty('--ratio', '100.0%');
tli.innerHTML = '<button type="button" class="thumbnail global-media-settings"><img alt="" hidden></button>';
th.insertBefore(tli, th0);
tli.querySelector('button').addEventListener('click', function () { showGal(li, false); });
li._th = tli;
}
try { var sc = list.closest('slider-component'); if (sc && sc.initPages) sc.initPages(); } catch (e) {}
return li;
}
function showGal(li, scroll) {
var g = document.querySelector('media-gallery');
try { if (g && g.setActiveMedia) g.setActiveMedia(li.getAttribute('data-media-id'), false); } catch (e) {}
try { li.parentNode.scrollTo({ left: li.offsetLeft, behavior: 'smooth' }); } catch (e) {}
if (scroll === false) return;
var top = (g || li).getBoundingClientRect().top + window.pageYOffset - 90;
window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}
function aiPreview(upwrap) {
var box2 = upwrap.querySelector('.updpx-aiprev');
var photo = upwrap.querySelector('input[type=hidden]:not([data-custom="_preview"])');
var out = upwrap.querySelector('input[data-custom="_preview"]');
if (!box2 || !photo || !photo.value) return;
var ask = upwrap.querySelector('.updpx-aiprev-ask');
if (ask) ask.hidden = true;
var n = parseInt(upwrap.dataset.prevN || '0', 10);
if (n >= 4) return;
upwrap.dataset.prevN = String(n + 1);
var name = rowName(upwrap);
upwrap.dataset.prevName = name;
upwrap.dataset.prevPhoto = photo.value;
var seq = String(Date.now());
upwrap.dataset.prevSeq = seq;
var img = box2.querySelector('.updpx-aiprev-img');
var wait = box2.querySelector('.updpx-aiprev-wait');
var msg = box2.querySelector('.updpx-aiprev-msg');
var li = galSlide(upwrap);
var gImg = li && li.querySelector('img');
var gWait = li && li.querySelector('.updpx-galprev-wait');
var tImg = li && li._th && li._th.querySelector('img');
if (li && li._th) li._th.querySelector('button').style.backgroundImage = 'url("' + photo.value + '")';
if (upwrap._pstop) upwrap._pstop(false);
var bars = [box2.querySelector('.updpx-pbar i'), li && li.querySelector('.updpx-pbar i')];
var t0 = Date.now();
var piv = setInterval(function () { var w = 96 * (1 - Math.exp(-(Date.now() - t0) / 13000)); bars.forEach(function (x) { if (x) x.style.width = w.toFixed(1) + '%'; }); }, 200);
var pstop = upwrap._pstop = function (ok) { clearInterval(piv); bars.forEach(function (x) { if (x) x.style.width = ok ? '100%' : '0'; }); };
box2._li = li;
box2.classList.toggle('is-gal', !!li);
box2.hidden = false;
if (out) out.value = '';
if (wait) { wait.hidden = false; wait.classList.remove('is-err'); }
if (msg) msg.textContent = upwrap.dataset.wWait || '…';
if (li) {
li.querySelector('.updpx-galprev-in').style.backgroundImage = 'url("' + photo.value + '")';
if (gWait) { gWait.hidden = false; gWait.classList.remove('is-err'); gWait.querySelector('.updpx-galprev-msg').textContent = upwrap.dataset.wWait || '…'; }
showGal(li);
}
var fail = function () {
if (upwrap.dataset.prevSeq !== seq) return;
pstop(false);
[wait, gWait].forEach(function (w) { if (!w) return; w.classList.add('is-err'); var m = w.querySelector('.updpx-aiprev-msg, .updpx-galprev-msg'); if (m) m.textContent = upwrap.dataset.wUnavail || ''; });
if (img && img.getAttribute('src')) { img.hidden = false; if (wait) wait.hidden = true; if (gWait) gWait.hidden = true; }
};
fetch(previewEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ product: box.dataset.product, option: parseInt(upwrap.dataset.cidx || '0', 10), photo: photo.value, name: name }) })
.then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
.then(function (d) {
if (!d || !d.id) return fail();
var tries = 0;
var poll = function () {
if (upwrap.dataset.prevSeq !== seq) return;
if (++tries > 60) return fail();
fetch(previewEndpoint + '?id=' + encodeURIComponent(d.id)).then(function (r) { return r.json(); }).then(function (s) {
if (upwrap.dataset.prevSeq !== seq) return;
if (s && s.url) {
pstop(true);
[img, gImg, tImg].forEach(function (x) { if (x) { x.src = s.url; x.hidden = false; } });
setTimeout(function () { [wait, gWait].forEach(function (x) { if (x) x.hidden = true; }); }, 350);
if (out) out.value = s.url;
} else if (s && s.status === 'failed') fail();
else setTimeout(poll, 3000);
}).catch(function () { setTimeout(poll, 4000); });
};
setTimeout(poll, 6000);
})
.catch(fail);
}
function nameUp(el) {
var row = el.closest('[data-row]') || el.closest('.updpx-var-opts');
return row && row.querySelector('[data-custupload][data-preview="1"]');
}
box.addEventListener('change', function (e) {
if ((e.target.type !== 'text' && e.target.type !== 'search') || !e.target.hasAttribute('data-custom')) return;
var up = nameUp(e.target);
var ph = up && up.querySelector('input[type=hidden]:not([data-custom="_preview"])');
if (!ph || !ph.value) return;
var v = (e.target.value || '').trim().slice(0, 30);
if (!up.dataset.prevSeq ? !!v : v !== (up.dataset.prevName || '')) aiPreview(up);
});
box.addEventListener('keydown', function (e) {
if (e.key === 'Enter' && (e.target.type === 'text' || e.target.type === 'search') && e.target.hasAttribute('data-custom') && nameUp(e.target)) { e.preventDefault(); e.target.blur(); }
});
box.addEventListener('click', function (e) {
var sk = e.target.closest('.updpx-aiprev-skip');
if (sk) { e.preventDefault(); var su = sk.closest('[data-custupload]'); if (su) aiPreview(su); return; }
var bx = e.target.closest('.updpx-aiprev-box');
if (!bx) return;
var p2 = bx.closest('.updpx-aiprev');
if (p2 && p2._li) showGal(p2._li);
else { var im = bx.querySelector('.updpx-aiprev-img'); if (im && im.src && !im.hidden) window.open(im.src, '_blank'); }
});
function attachSwName(holder, sel) {
var wrap = sel.closest('[data-optwrap], [data-customwrap]');
if (!wrap) return;
wrap.classList.add('has-sw');
var name = wrap.querySelector('.updpx-sw-name');
if (!name) { name = document.createElement('span'); name.className = 'updpx-sw-name'; holder.insertAdjacentElement('afterend', name); }
var upd = function () {
var o = sel.selectedOptions && sel.selectedOptions[0];
name.textContent = o ? (o.dataset.label || o.value) : '';
};
sel.addEventListener('change', upd); upd();
}
function buildCustomSwatches(row) {
row.querySelectorAll('[data-cswatches]').forEach(function (holder) {
var sel = row.querySelector('select[data-cidx="' + holder.dataset.cswatches + '"]');
if (!sel) return;
holder.innerHTML = '';
Array.prototype.forEach.call(sel.options, function (o) {
if (!o.value || !o.dataset.image) return;
var b = document.createElement('button');
b.type = 'button'; b.className = 'updpx-sw'; b.title = o.value; b.setAttribute('aria-label', o.value); b.dataset.val = o.value;
var img = document.createElement('img'); img.src = o.dataset.image; img.alt = o.value; img.loading = 'lazy';
b.appendChild(img);
b.addEventListener('click', function (e) { e.stopPropagation(); sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); });
holder.appendChild(b);
});
holder.hidden = holder.children.length === 0;
if (!holder.hidden) attachSwName(holder, sel);
var sync = function () { holder.querySelectorAll('.updpx-sw').forEach(function (b) { b.classList.toggle('is-sel', b.dataset.val === sel.value); }); var w = sel.closest('[data-customwrap]'); if (w && sel.value) w.classList.remove('is-missing'); };
sel.addEventListener('change', sync); sync();
});
}
function valueAvailable(opts, i, val) {
return variants.some(function (x) {
if (x.available === false || optVal(x, i) !== val) return false;
for (var j = 0; j < 3; j++) { if (j !== i && opts[j] != null && optVal(x, j) !== opts[j]) return false; }
return true;
});
}
var imageByOpt = {};
(box.querySelector('.updpx-var-row select') ? [0, 1, 2] : []).forEach(function (i) {
var map = {}, distinct = {};
variants.forEach(function (x) {
var val = optVal(x, i); var src = x.featured_image && x.featured_image.src;
if (val == null || !src || map[val]) return;
map[val] = src; distinct[src] = 1;
});
if (Object.keys(map).length >= 2 && (Object.keys(distinct).length >= 2 || i === colorOpt)) imageByOpt[i] = map;
});
function thumb(src) { var q = src.indexOf('?'); var base = q >= 0 ? src.slice(0, q) : src; var tail = q >= 0 ? src.slice(q) : ''; var dot = base.lastIndexOf('.'); if (dot < 0 || base.length - dot > 6) return src; return base.slice(0, dot) + '_120x120' + base.slice(dot) + tail; }
function buildSwatches(row) {
var thumbImg = null;
row.querySelectorAll('[data-swatches]').forEach(function (holder) {
holder.hidden = true;
var i = parseInt(holder.dataset.swatches, 10);
var map = imageByOpt[i];
if (!map) return;
var sel = row.querySelector('select[data-opt="' + i + '"]');
if (!sel) return;
if (!thumbImg) {
thumbImg = document.createElement('img');
thumbImg.className = 'updpx-var-thumb'; thumbImg.alt = ''; thumbImg.loading = 'lazy';
var wrap = sel.parentNode;
wrap.classList.add('has-thumb');
wrap.insertBefore(thumbImg, sel);
}
var img = thumbImg;
var upd = function () { var src = map[sel.value]; if (src) { img.src = thumb(src); img.alt = sel.value; img.hidden = false; } };
sel.addEventListener('change', upd); upd();
});
}
function refreshRow(row) {
var opts = rowValues(row);
row.querySelectorAll('select').forEach(function (s) {
var i = parseInt(s.dataset.opt, 10);
var firstOk = null;
Array.prototype.forEach.call(s.options, function (o) {
var ok = valueAvailable(opts, i, o.value);
o.disabled = !ok;
o.textContent = ok ? (o.dataset.label || o.value) : (o.dataset.label || o.value) + ' — ' + soldOut;
if (ok && firstOk == null) firstOk = o.value;
});
if (s.selectedOptions[0] && s.selectedOptions[0].disabled && firstOk != null) { s.value = firstOk; opts[i] = firstOk; }
});
row.querySelectorAll('[data-swatches] .updpx-sw').forEach(function (b) {
var i = parseInt(b.parentNode.dataset.swatches, 10);
var ok = valueAvailable(opts, i, b.dataset.val);
b.classList.toggle('is-out', !ok);
b.classList.toggle('is-sel', opts[i] === b.dataset.val);
});
var v = resolveRow(row);
var good = !!v && v.available !== false;
row.classList.toggle('is-out', !good);
row.style.outline = good ? '' : '2px solid #d33';
}
box.querySelectorAll('[data-row]').forEach(function (row) { buildSwatches(row); buildCustomSwatches(row); });
if (hasVars) box.querySelectorAll('[data-row]').forEach(refreshRow);
var nameOpt = -1, nameMax = 0;
var nameWord = ({ fr: 'Prénom', de: 'Name', it: 'Nome', es: 'Nombre', nl: 'Naam', pt: 'Nome' })[((document.documentElement && document.documentElement.lang) || '').slice(0, 2).toLowerCase()] || 'Name';
if (hasVars) {
var nr0 = box.querySelector('[data-row]');
if (nr0) nr0.querySelectorAll('select[data-opt]').forEach(function (s) {
var i = parseInt(s.dataset.opt, 10);
if (nameOpt >= 0 || hiddenOpts.indexOf(i) >= 0) return;
var vals = Array.prototype.map.call(s.options, function (o) { return o.value; });
if (vals.length < 2 || !vals.every(function (v) { return /^ *[0-9]+ *[^0-9 ]/.test(v); })) return;
if (!/pr[ée]nom|(^|[^a-z])noms?([^a-z]|$)|names?|namen|(^|[^a-z])nomi([^a-z]|$)|nombres?|initial|lettre|letter|buchstab|gravur|engrav|incisi/i.test((s.getAttribute('aria-label') || '') + ' ' + vals.join(' '))) return;
nameOpt = i;
nameMax = Math.min(10, Math.max.apply(null, vals.map(function (v) { return parseInt(v, 10) || 1; })));
});
}
function syncNames(row) {
if (nameOpt < 0 || !row) return;
var holder = row.querySelector('.updpx-names');
if (!holder) {
holder = document.createElement('div');
holder.className = 'updpx-names';
for (var k = 1; k <= nameMax; k++) {
var w = document.createElement('div');
w.className = 'updpx-var-opt updpx-name-f';
w.setAttribute('data-customwrap', 'n' + k);
var inp = document.createElement('input');
inp.type = 'search'; inp.maxLength = 15; inp.style.width = '100%'; inp.placeholder = nameWord + ' ' + k;
inp.setAttribute('data-custom', nameWord + ' ' + k);
inp.setAttribute('aria-label', nameWord + ' ' + k);
inp.setAttribute('enterkeyhint', 'next');
['autocomplete', 'autocorrect'].forEach(function (a) { inp.setAttribute(a, 'off'); });
inp.setAttribute('autocapitalize', 'words'); inp.setAttribute('spellcheck', 'false');
w.appendChild(inp);
holder.appendChild(w);
}
holder.style.cssText = 'flex:1 1 100%;width:100%;display:grid;gap:.5rem';
(row.querySelector('.updpx-var-opts') || row).appendChild(holder);
}
var sel = row.querySelector('select[data-opt="' + nameOpt + '"]');
var n = Math.max(1, Math.min(nameMax, sel ? parseInt(sel.value, 10) || 1 : 1));
holder.setAttribute('data-n', String(n));
holder.style.gridTemplateColumns = n > 1 ? 'minmax(0,1fr) minmax(0,1fr)' : 'minmax(0,1fr)';
holder.querySelectorAll('.updpx-name-f').forEach(function (w, k) { w.hidden = k >= n; w.style.display = k >= n ? 'none' : ''; if (k >= n) w.classList.remove('is-missing'); });
}
if (nameOpt >= 0) {
hasCustom = true;
box.querySelectorAll('[data-row]').forEach(syncNames);
box.addEventListener('change', function (e) { if (e.target.tagName === 'SELECT' && e.target.dataset.opt != null) syncNames(e.target.closest('[data-row]')); });
box.addEventListener('input', function (e) { var w = e.target.closest && e.target.closest('.updpx-name-f'); if (w && e.target.value.trim()) w.classList.remove('is-missing'); });
box.addEventListener('keydown', function (e) {
if (e.key !== 'Enter' || !e.target.closest || !e.target.closest('.updpx-name-f')) return;
e.preventDefault();
var all = Array.prototype.filter.call(e.target.closest('.updpx-names').querySelectorAll('input'), function (x) { return !x.closest('[hidden]'); });
var nx = all[all.indexOf(e.target) + 1];
if (nx) nx.focus(); else e.target.blur();
});
}
function baseName(u) { try { var b = String(u || '').split('?')[0]; b = b.slice(b.lastIndexOf('/') + 1); return b.replace(/_[0-9]+x[0-9]*(@[0-9]x)?(?=.[a-z]+$)/i, '').toLowerCase(); } catch (err) { return ''; } }
function showVariantMedia(v) {
if (!v) return;
var mid = v.featured_media && v.featured_media.id;
var item = null;
if (mid) item = document.querySelector('[data-media-id$="-' + mid + '"], [data-media-id="' + mid + '"]');
if (!item && v.featured_image && v.featured_image.src) {
var want = baseName(v.featured_image.src);
var imgs = document.querySelectorAll('media-gallery img, .product__media-list img, .product__media img, [data-media-id] img');
for (var k = 0; k < imgs.length && want; k++) { if (baseName(imgs[k].currentSrc || imgs[k].src) === want) { item = imgs[k].closest('[data-media-id]') || imgs[k].closest('li, .product__media-item') || imgs[k]; break; } }
}
if (!item) return;
var full = item.getAttribute && item.getAttribute('data-media-id');
var gal = item.closest ? item.closest('media-gallery') : null;
if (gal && typeof gal.setActiveMedia === 'function' && full) { try { gal.setActiveMedia(full, true); return; } catch (err) { /* repli */ } }
if (full) { var th = document.querySelector('.thumbnail[data-target="' + full + '"], [data-target="' + full + '"]'); if (th) { th.click(); return; } }
var slider = item.closest ? item.closest('.slider, .product__media-list') : null;
if (slider && slider.scrollTo) slider.scrollTo({ left: item.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
else if (item.scrollIntoView) item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
}
box.addEventListener('change', function (e) {
if (e.target.tagName !== 'SELECT' || e.target.hasAttribute('data-custom')) return;
var row = e.target.closest('[data-row]');
refreshRow(row);
var cv = resolveRow(row);
var vars = row && row.closest('.updpx-tier-vars');
var owner = (row && row.closest('.updpx-tier')) || (vars && vars._updpxOwner) || null;
if (owner && vars) {
var units = [];
vars.querySelectorAll('[data-row]').forEach(function (r) { units.push(resolveRow(r)); });
if (units.every(Boolean)) priceTier(owner, units);
} else updateTierPricesForVariant(cv);
var oi = parseInt(e.target.dataset.opt, 10);
if (imageByOpt[oi]) showVariantMedia(cv);
});
document.addEventListener('submit', function (e) {
var form = e.target;
if (!form.action || form.action.indexOf('/cart/add') === -1) return;
var selTier = box.querySelector('.updpx-tier.is-sel');
if (!selTier) return;
if (allHidden && unitVar) { var uIn = form.querySelector('input[name="id"]'); if (uIn) uIn.value = String(unitVar.id); }
var code = selTier.getAttribute('data-updpx-code') || '';
var giftV = selTier.getAttribute('data-updpx-giftvariant') || '';
var gifts = [];
try { gifts = JSON.parse(selTier.getAttribute('data-updpx-gifts') || '[]') || []; } catch (err) { gifts = []; }
var upsellEls = box.querySelectorAll('[data-updpx-upsell]:checked');
if (!hasVars && !hasCustom && !code && !giftV && !gifts.length && !abId && !upsellEls.length) {
setQtyOn(form, parseInt(selTier.dataset.updpxQty, 10) || 1);
var nbtn = form.querySelector('button[type="submit"], [name="add"]');
if (nbtn && !nbtn.querySelector('.updpx-spin')) { var nsp = document.createElement('span'); nsp.className = 'updpx-spin'; nbtn.appendChild(nsp); }
return; // flux natif : le spinner montre le chargement jusqu'à la navigation
}
e.preventDefault();
e.stopImmediatePropagation();
var counts = {};
var lines = []; // articles avec propriétés (une ligne par unité personnalisée)
if (hasVars || hasCustom) {
var bad = false, missing = false;
selTier.querySelectorAll('[data-row]').forEach(function (row) {
var v = resolveRow(row);
if (!v || v.available === false) { bad = true; row.style.outline = '2px solid #d33'; return; }
row.style.outline = '';
if (hasCustom) {
var props = rowProps(row);
if (!props) { missing = true; return; }
lines.push({ id: v.id, quantity: 1, properties: props });
} else {
counts[v.id] = (counts[v.id] || 0) + 1;
}
});
if (bad) { alert('Une des combinaisons choisies est indisponible.'); return; }
if (missing) { alert(chooseMsg); return; }
} else {
var idInput = form.querySelector('input[name="id"]');
if (!idInput) return;
counts[idInput.value] = parseInt(selTier.dataset.updpxQty, 10) || 1;
}
if (giftV && !gifts.length) counts[giftV] = (counts[giftV] || 0) + (parseInt(selTier.getAttribute('data-updpx-giftqty'), 10) || 1);
gifts.forEach(function (g) { if (g && g.v) counts[g.v] = (counts[g.v] || 0) + (parseInt(g.q, 10) || 1); });
var btn = form.querySelector('button[type="submit"], [name="add"]');
var stopLoad = function () { if (!btn) return; btn.removeAttribute('disabled'); var sp = btn.querySelector('.updpx-spin'); if (sp) sp.remove(); };
if (btn) { btn.setAttribute('disabled', ''); if (!btn.querySelector('.updpx-spin')) { var sp0 = document.createElement('span'); sp0.className = 'updpx-spin'; btn.appendChild(sp0); } }
var openDrawer = function (data) {
try {
var drawer = document.querySelector('cart-drawer');
if (!drawer || typeof drawer.renderContents !== 'function' || !data || !data.sections) return false;
drawer.classList.remove('is-empty');
drawer.renderContents(data);
return true;
} catch (err) { return false; }
};
var abItems = lines.concat(Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; }));
if (abId) abItems.forEach(function (it) { it.properties = it.properties || {}; it.properties._ab_variant = abId; });
upsellEls.forEach(function (el) {
var uid = parseInt(el.getAttribute('data-updpx-upsell'), 10);
if (uid) abItems.push({ id: uid, quantity: 1 });
});
abItems.reverse();
var doAdd = function () {
abBeacon('atc');
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({
items: abItems,
sections: 'cart-drawer,cart-icon-bubble',
sections_url: window.location.pathname
})
}).then(function (r) {
if (!r.ok) throw new Error('add failed');
return r.json();
}).then(function (data) {
stopLoad();
if (!openDrawer(data)) window.location.href = '/cart';
}).catch(function () {
stopLoad();
alert('Ajout au panier impossible, merci de reessayer.');
});
};
if (code) { fetch('/discount/' + encodeURIComponent(code)).then(doAdd, doAdd); } else { doAdd(); }
}, true);
})();
